import { jsxs, jsx } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { IconInfo, IconWarning, IconError } from "@bynder/icons";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
const defaultIcons = {
  info: /* @__PURE__ */ jsx(IconInfo, {}),
  warning: /* @__PURE__ */ jsx(IconWarning, {}),
  error: /* @__PURE__ */ jsx(IconError, {}),
  neutral: null
};
function InlineBanner({
  children,
  title,
  icon: iconProp,
  link,
  variant = "neutral",
  ...props
}) {
  const icon = iconProp || defaultIcons[variant];
  return /* @__PURE__ */ jsxs(InlineBannerStyled, {
    $variant: variant,
    ...props,
    children: [icon && /* @__PURE__ */ jsx(IconHolder, {
      children: icon
    }), /* @__PURE__ */ jsxs(TextWrapper, {
      children: [title && /* @__PURE__ */ jsx(TitleHolder, {
        children: title
      }), /* @__PURE__ */ jsx(DescriptionHolder, {
        children
      }), link && /* @__PURE__ */ jsx(LinkHolder, {
        children: link
      })]
    })]
  });
}
const InlineBannerStyled = styled.div.withConfig({
  displayName: "InlineBannerStyled",
  componentId: "sc-12uyq5a-0"
})(["", " display:flex;align-items:flex-start;padding:", " ", ";border-radius:", ";background:var(--background-color);"], (props) => {
  if (props.$variant === "info") {
    return css(["--background-color:", ";--icon-color:", ";--link-color:", ";--link-color-hover:", ";"], token.blue500a10, token.blue500, token.blue600, token.blue700);
  } else if (props.$variant === "warning") {
    return css(["--background-color:", ";--icon-color:", ";--link-color:", ";--link-color-hover:", ";"], token.yellow500a10, token.yellow500, token.yellow600, token.yellow700);
  } else if (props.$variant === "error") {
    return css(["--background-color:", ";--icon-color:", ";--link-color:", ";--link-color-hover:", ";"], token.red500a10, token.red500, token.red600, token.red700);
  }
  return css(["--background-color:", ";--icon-color:", ";--link-color:", ";--link-color-hover:", ";"], token.gray50, token.gray500, token.blue600, token.blue700);
}, token.spacing4, token.spacing4, token.radiusMedium);
const IconHolder = styled.div.withConfig({
  displayName: "IconHolder",
  componentId: "sc-12uyq5a-1"
})(["display:flex;width:24px;height:24px;margin-right:", ";color:var(--icon-color);"], token.spacing3);
const TextWrapper = styled.div.withConfig({
  displayName: "TextWrapper",
  componentId: "sc-12uyq5a-2"
})(["align-self:center;"]);
const TitleHolder = styled.div.withConfig({
  displayName: "TitleHolder",
  componentId: "sc-12uyq5a-3"
})(["", " margin-bottom:", ";color:", ";"], textStyles.uiTextM, token.spacing2, token.gray1000);
const DescriptionHolder = styled.div.withConfig({
  displayName: "DescriptionHolder",
  componentId: "sc-12uyq5a-4"
})(["", " color:", ";"], textStyles.uiTextS, token.gray800);
const LinkHolder = styled.div.withConfig({
  displayName: "LinkHolder",
  componentId: "sc-12uyq5a-5"
})(["", " margin-top:", ";a{color:var(--link-color);text-decoration:none;}a:hover{color:var(--link-color-hover);}a:focus-visible{border-radius:2px;box-shadow:0 0 0 2px ", ";outline:none;}"], textStyles.uiTextS, token.spacing2, token.blue500);
export {
  InlineBanner
};
//# sourceMappingURL=InlineBanner.js.map
